import styled from 'styled-components';
import TextStyle from '@rezdy/components/TextStyle';
import { H2 } from '@rezdy/components/Heading';

export const SecondaryText = styled(TextStyle as any)`
    color: #fff;
`;

export const Title = styled(H2 as any)`
    font-weight: 900;
    line-height: 1.15;
    margin: 0 auto;
`;

export const Color = styled.span`
    color: ${props => props.color};
`;
